import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import _ from 'lodash'
import App from './App.vue'

// 将 lodash 挂载到 window 对象上，以覆盖 ElementUI 内部可能暴露的旧版本 lodash
window._ = _
console.log('Lodash version loaded:', _.VERSION)
import router from './router'
import './assets/css/style.css'
import apiClient, { getRequest, postRequest } from '@/api/api'
import { devConsoleUrl, prodConsoleUrl } from './config';

// 注册全局实例
Vue.prototype.$api = apiClient;

// 注册通用方法（可选）
Vue.prototype.$get = getRequest;
Vue.prototype.$post = postRequest;


// 判断当前环境
const isDev = process.env.NODE_ENV === 'development';
// 控制台路径
Vue.prototype.$consoleUrl = isDev ? devConsoleUrl : prodConsoleUrl;


Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')